import { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import {
    Login,
    AdminHome,
    CoordinatorsTable,
    TreatmentsTable,
    ViewTreatmentCourse,
    CoordinatorHomePage,
    TreatmentForm,
    UpdateCoordinator,
    ViewTreatment,
    UpdateTreatment,
    CoordinatorForm,
    TreatmentCourseForm,
    UpdateTreatmentCourseForm,
    PatientTreatmentCourseView,
    AlreadySignedDocument
} from './pages';
import IsAlreadyAuth from '@/guards/IsAlreadyAuth';
import AuthGuard from '@/guards/AuthGuard';
import { Roles } from '@/utils/types';
import Header from '@/components/Header';
import FullPageLoader from '@/components/FullPageLoader';
import NotFoundPage from '@/components/NotFoundPage';

const Routers = () => (
    <BrowserRouter>
        <Suspense fallback={<FullPageLoader />}>
            <Header />
            <Routes>
                <Route path="/" element={<Navigate to={'/coordinators/login'} />} />
                {/* Admin Routes */}
                <Route element={<AuthGuard redirectTo="/admins/login" allowedRoles={[Roles.Admin, Roles.Root]} />}>
                    <Route path="/home" element={<AdminHome />} />

                    <Route path="/treatments" element={<TreatmentsTable />} />
                    <Route path="/treatments/create" element={<TreatmentForm />} />
                    <Route path="/treatments/update/:treatmentId" element={<UpdateTreatment />} />
                    <Route path="/treatments/view/:treatmentId" element={<ViewTreatment />} />

                    <Route path="/coordinators" element={<CoordinatorsTable />} />
                    <Route path="/coordinators/create" element={<CoordinatorForm />} />
                    <Route path="/coordinators/update/:coordinatorId" element={<UpdateCoordinator />} />
                </Route>

                {/* Coordinators Routes */}
                <Route element={<AuthGuard redirectTo="/coordinators/login" allowedRoles={[Roles.Coordinator]} />}>
                    <Route path="/coordinator-home" element={<CoordinatorHomePage />} />
                    <Route path="/treatment-course/create" element={<TreatmentCourseForm />} />
                    <Route path="/treatment-course/update/:courseId" element={<UpdateTreatmentCourseForm />} />
                    <Route path="/treatment-course/view/:courseId" element={<ViewTreatmentCourse />} />
                </Route>

                <Route element={<IsAlreadyAuth />}>
                    <Route path="/admins/login" element={<Login target="admins" />} />
                </Route>
                <Route element={<IsAlreadyAuth />}>
                    <Route path="/coordinators/login" element={<Login target="coordinators" />} />
                </Route>
                <Route path="/course/:courseId" element={<PatientTreatmentCourseView />} />
                <Route path="/course/signed" element={<AlreadySignedDocument />} />
                
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Suspense>
    </BrowserRouter>
);

export default Routers;
